export const METRIC_COLUMNS_BY_ENTITY: Record<string, string[]> = {
  category: [
    "sales",
    "units",
    "ad_sales",
    "ad_spend",
    "cost",
    "roas",
    "acos",
    "clicks",
    "impressions",
    "ctr",
    "orders",
    "conversion_rate",
    "total_conv_rate",
    "organic_sales",
    "organic_units",
    "organic_page_views",
    "org_conv_rate",
    "cpc",
    "roms",
    "margin",
    "margin_wo_adspend",
    "profit",
    "profit_wo_adspend",
    "ad_sales_same_sku",
    "troas",
    "roas_same_sku",
    "total_acos",
    "acos_same_sku",
    "page_views",
    "orders_same_sku",
    "cogs",
    "taov",
    "tauv",
    "aaov",
    "aauv",
    "ssaov",
    "ssauv",
    "average_daily_spend",
    "average_daily_sales",
    "day_range",
  ],
  organization: [
    "sales",
    "units",
    "roas",
    "acos",
    "margin",
    "ad_sales",
    "ad_spend",
    "roms",
    "cost",
    "clicks",
    "impressions",
    "ctr",
    "orders",
    "conversion_rate",
    "cpc",
    "margin_wo_adspend",
    "profit",
    "profit_wo_adspend",
    "ad_sales_same_sku",
    "troas",
    "roas_same_sku",
    "total_acos",
    "acos_same_sku",
    "total_conv_rate",
    "organic_sales",
    "org_conv_rate",
    "organic_units",
    "organic_page_views",
    "page_views",
    "orders_same_sku",
    "cogs",
    "taov",
    "tauv",
    "aaov",
    "aauv",
    "ssaov",
    "ssauv",
    "average_daily_spend",
    "average_daily_sales",
    "day_range",
  ],

  mediaPlan: [
    "ad_sales",
    "ad_spend",
    "roas",
    "acos",
    "clicks",
    "impressions",
    "ctr",
    "orders",
    "conversion_rate",
    "cpc",
    "serving_hours",
    "sales",
    "roms",
    "units",
    "ad_sales_same_sku",
    "roas_same_sku",
    "acos_same_sku",
    "orders_same_sku",
    "taov",
    "tauv",
    "aaov",
    "aauv",
    "ssaov",
    "ssauv",
    "average_daily_spend",
    "average_daily_sales",
    "day_range",
    "top_of_search_impression_share",
    "kenp_pages_read",
    "kenp_royalties",
    "acos_with_kenp",
  ],
  product: [
    "ad_sales",
    "ad_spend",
    "cost",
    "roas",
    "acos",
    "clicks",
    "impressions",
    "price",
    "ctr",
    "orders",
    "conversion_rate",
    "cpc",
    "sales",
    "roms",
    "units",
    "total_orders",
    "margin",
    "margin_wo_adspend",
    "ad_sales_same_sku",
    "troas",
    "roas_same_sku",
    "total_acos",
    "acos_same_sku",
    "total_conv_rate",
    "organic_sales",
    "organic_units",
    "organic_page_views",
    "org_conv_rate",
    "bsr",
    "page_views",
    "orders_same_sku",
    "min_price",
    "max_price",
    "suggested_price",
    "seo_score",
    "buyability_score",
    "profit_per_page_view",
    "profit_per_page_view_wo_adspend",
    "profit",
    "profit_wo_adspend",
    "boosted_profit",
    "cogs",
    "taov",
    "tauv",
    "aaov",
    "aauv",
    "ssaov",
    "ssauv",
    "average_daily_spend",
    "average_daily_sales",
    "day_range",
  ],

  productAd: [
    "ad_sales",
    "ad_spend",
    "roas",
    "acos",
    "clicks",
    "impressions",
    "ctr",
    "price",
    "orders",
    "conversion_rate",
    "cpc",
    "ad_sales_same_sku",
    "roas_same_sku",
    "aaov",
    "aauv",
    "ssaov",
    "ssauv",
    "average_daily_spend",
    "average_daily_sales",
    "day_range",
    "acos_same_sku",
    "orders_same_sku",
  ],
  pricingPlan: [
    "state",
    "cost",
    "roas",
    "acos",
    "clicks",
    "impressions",
    "ctr",
    "orders",
    "conversion_rate",
    "cpc",
    "enroll_date",
    "sales",
    "target_sales",
    "roms",
    "units",
    "total_orders",
    "margin",
    "margin_wo_adspend",
    "ad_sales_same_sku",
    "troas",
    "roas_same_sku",
    "total_acos",
    "acos_same_sku",
    "profit",
    "profit_wo_adspend",
    "profit_expcectations",
    "total_conv_rate",
    "cogs",
    "page_views",
    "orders_same_sku",
    "profit_per_page_view",
    "profit_per_page_view_wo_adspend",
    "boosted_profit",
  ],
  target: [
    "ad_spend",
    "ad_sales",
    "orders",
    "acos",
    "conversion_rate",
    "cpc",
    "clicks",
    "impressions",
    "ctr",
    "roas",
    "troas",
    "aaov",
    "aauv",
    "average_daily_spend",
    "average_daily_sales",
    "day_range",
    "top_of_search_impression_share",
  ],
  searchTerm: [
    "ad_spend",
    "ad_sales",
    "orders",
    "acos",
    "roas",
    "conversion_rate",
    "cpc",
    "clicks",
    "impressions",
    "ctr",
    "viewable_impressions",
    "viewability_rate",
    "view_click_through_rate",
    "adv_keyword_ids_count",
    "adv_target_ids_count",
  ],
  searchQuery: [
    "search_query_score",
    "search_query_volume",
    "impressions_total",
    "impressions_brand_or_asin",
    "impressions_brand_or_asin_share",
    "clicks_total",
    "clicks_total_rate",
    "clicks_brand_or_asin",
    "clicks_brand_or_asin_share",
    "clicks_price_median",
    "clicks_brand_or_asin_price_median",
    "clicks_same_day_shipping_speed",
    "clicks_1d_shipping_speed",
    "clicks_2d_shipping_speed",
    "ctr_total",
    "ctr_brand_or_asin",
    "cv_total",
    "cv_brand_or_asin",
    "cv_difference",
    "ctr_difference",
    "cart_adds_total",
    "cart_adds_total_rate",
    "cart_adds_brand_or_asin",
    "cart_adds_brand_or_asin_share",
    "cart_adds_price_median",
    "cart_adds_brand_or_asin_price_median",
    "cart_adds_same_day_shipping_speed",
    "cart_adds_1d_shipping_speed",
    "cart_adds_2d_shipping_speed",
    "purchases_total",
    "purchases_total_rate",
    "purchases_brand_or_asin",
    "purchases_brand_or_asin_share",
    "purchases_price_median",
    "purchases_brand_or_asin_price_median",
    "purchases_same_day_shipping_speed",
    "purchases_1d_shipping_speed",
    "purchases_2d_shipping_speed",
    "clicks",
    "impressions",
  ],
  searchQueryReport: [
    "search_query_score",
    "search_query_volume",
    "impressions_total",
    "impressions_brand_or_asin",
    "impressions_brand_or_asin_share",
    "clicks_total",
    "clicks_total_rate",
    "clicks_brand_or_asin",
    "clicks_brand_or_asin_share",
    "clicks_price_median",
    "clicks_brand_or_asin_price_median",
    "clicks_same_day_shipping_speed",
    "clicks_1d_shipping_speed",
    "clicks_2d_shipping_speed",
    "ctr_total",
    "ctr_brand_or_asin",
    "cv_total",
    "cv_brand_or_asin",
    "cv_difference",
    "ctr_difference",
    "cart_adds_total",
    "cart_adds_total_rate",
    "cart_adds_brand_or_asin",
    "cart_adds_brand_or_asin_share",
    "cart_adds_price_median",
    "cart_adds_brand_or_asin_price_median",
    "cart_adds_same_day_shipping_speed",
    "cart_adds_1d_shipping_speed",
    "cart_adds_2d_shipping_speed",
    "purchases_total",
    "purchases_total_rate",
    "purchases_brand_or_asin",
    "purchases_brand_or_asin_share",
    "purchases_price_median",
    "purchases_brand_or_asin_price_median",
    "purchases_same_day_shipping_speed",
    "purchases_1d_shipping_speed",
    "purchases_2d_shipping_speed",
    "purchases_same_day_shipping_speed_percentage",
    "purchases_1d_shipping_speed_percentage",
    "purchases_2d_shipping_speed_percentage",
    "clicks_keyword",
    "sales_keyword",
    "units_keyword",
    "cost_keyword",
    "conversions_keyword",
    "acos_keyword",
    "conversion_rate_keyword",
    "cpc_keyword",
  ],
  content: [
    "sales",
    "units",
    "ad_sales",
    "ad_spend",
    "cost",
    "roas",
    "acos",
    "clicks",
    "impressions",
    "ctr",
    "orders",
    "conversion_rate",
    "total_conv_rate",
    "organic_sales",
    "organic_units",
    "organic_page_views",
    "org_conv_rate",
    "cpc",
    "roms",
    "margin",
    "margin_wo_adspend",
    "profit",
    "profit_wo_adspend",
    "ad_sales_same_sku",
    "troas",
    "roas_same_sku",
    "total_acos",
    "acos_same_sku",
    "page_views",
    "orders_same_sku",
    "cogs",
    "taov",
    "tauv",
    "aaov",
    "aauv",
    "ssaov",
    "ssauv",
    "average_daily_spend",
    "average_daily_sales",
    "day_range",
    "seo_score",
    "buyability_score",
  ],
  spAudience: [
    "ad_sales",
    "ad_spend",
    "roas",
    "acos",
    "impressions",
    "clicks",
    "ctr",
    "orders",
    "conversion_rate",
    "cpc",
  ],
  dspCampaign: [
    "dsp_sales",
    "dsp_total_sales",
    "dsp_ecpm",
    "dsp_impressions",
    "dsp_clicks",
    "dsp_cost",
    "dsp_total_purchases",
    "dsp_units",
    "dsp_total_units",
    "dsp_ctr",
    "dsp_total_acos",
    "dsp_total_roas",
    "dsp_total_detail_page_views",
    "dsp_total_detail_page_view_rate",
    "dsp_total_add_to_cart",
    "dsp_new_to_brand_detail_page_views",
    "dsp_new_to_brand_detail_page_views_rate",
    "dsp_total_new_to_brand_dpvs",
    "dsp_total_new_to_brand_dpv_rate",
    "dsp_brand_searches",
    "dsp_brand_searches_rate",
  ],
  dspCreative: [
    "dsp_sales",
    "dsp_total_sales",
    "dsp_ecpm",
    "dsp_impressions",
    "dsp_clicks",
    "dsp_cost",
    "dsp_total_purchases",
    "dsp_units",
    "dsp_total_units",
    "dsp_ctr",
    "dsp_total_acos",
    "dsp_total_roas",
    "dsp_total_detail_page_views",
    "dsp_total_detail_page_view_rate",
    "dsp_total_add_to_cart",
    "dsp_new_to_brand_detail_page_views",
    "dsp_new_to_brand_detail_page_views_rate",
    "dsp_total_new_to_brand_dpvs",
    "dsp_total_new_to_brand_dpv_rate",
    "dsp_brand_searches",
    "dsp_brand_searches_rate",
  ],
  dspLineItem: [
    "dsp_sales",
    "dsp_total_sales",
    "dsp_ecpm",
    "dsp_impressions",
    "dsp_viewable_impressions",
    "dsp_viewability",
    "dsp_clicks",
    "dsp_cost",
    "dsp_total_purchases",
    "dsp_units",
    "dsp_total_units",
    "dsp_ctr",
    "dsp_total_acos",
    "dsp_total_roas",
    "dsp_total_detail_page_views",
    "dsp_total_detail_page_view_rate",
    "dsp_total_add_to_cart",
    "dsp_new_to_brand_detail_page_views",
    "dsp_new_to_brand_detail_page_views_rate",
    "dsp_total_new_to_brand_dpvs",
    "dsp_total_new_to_brand_dpv_rate",
    "dsp_brand_searches",
    "dsp_brand_searches_rate",
  ],
  dspAudience: [
    "dsp_sales",
    "dsp_total_sales",
    "dsp_ecpm",
    "dsp_impressions",
    "dsp_clicks",
    "dsp_cost",
    "dsp_total_purchases",
    "dsp_units",
    "dsp_total_units",
    "dsp_ctr",
    "dsp_total_acos",
    "dsp_total_roas",
    "dsp_total_detail_page_views",
    "dsp_total_detail_page_view_rate",
    "dsp_total_add_to_cart",
    "dsp_new_to_brand_detail_page_views",
    "dsp_new_to_brand_detail_page_views_rate",
    "dsp_total_new_to_brand_dpvs",
    "dsp_total_new_to_brand_dpv_rate",
    "dsp_brand_searches",
    "dsp_brand_searches_rate",
  ],
  dspInventory: [
    "dsp_sales",
    "dsp_total_sales",
    "dsp_ecpm",
    "dsp_impressions",
    "dsp_clicks",
    "dsp_cost",
    "dsp_total_purchases",
    "dsp_units",
    "dsp_total_units",
    "dsp_ctr",
    "dsp_total_acos",
    "dsp_total_roas",
    "dsp_total_detail_page_views",
    "dsp_total_detail_page_view_rate",
    "dsp_total_add_to_cart",
    "dsp_new_to_brand_detail_page_views",
    "dsp_new_to_brand_detail_page_views_rate",
    "dsp_total_new_to_brand_dpvs",
    "dsp_total_new_to_brand_dpv_rate",
    "dsp_brand_searches",
    "dsp_brand_searches_rate",
  ],
  dspProduct: [
    "dsp_total_detail_page_views",
    "dsp_new_to_brand_detail_page_views",
    "dsp_total_add_to_cart",
    "dsp_total_purchases",
    "dsp_total_new_to_brand_dpvs",
    "dsp_total_units",
  ],
  dspGeo: ["dsp_total_detail_page_views", "dsp_total_add_to_cart", "dsp_total_new_to_brand_dpvs", "dsp_total_units"],
};

export const COMPARE_METRIC_LOOKUP: Record<string, string> = {
  ad_sales: "ad_sales_percent",
  ad_spend: "ad_spend_percent",
  cost: "cost_percent",
  roas: "roas_delta",
  acos: "acos_delta",
  clicks: "clicks_percent",
  impressions: "impressions_percent",
  ctr: "ctr_delta",
  orders: "conversion_percent",
  conversion: "conversion_percent",
  conversion_rate: "conversion_rate_delta",
  cpc: "cpc_delta",
  serving_hours: "serving_hours_delta",
  sales: "sales_percent",
  roms: "roms_delta",
  units: "units_percent",
  total_orders: "total_order_count_percent",
  margin: "margin_delta",
  margin_wo_adspend: "margin_wo_adspend_delta",
  ad_sales_same_sku: "ad_sales_same_sku_percent",
  troas: "troas_delta",
  roas_same_sku: "roas_same_sku_delta",
  total_acos: "total_acos_delta",
  acos_same_sku: "acos_same_sku_delta",
  profit: "profit_percent",
  profit_wo_adspend: "profit_wo_adspend_percent",
  price: "price_delta",
  min_price: "price_delta",
  total_conv_rate: "total_conv_rate_delta",
  organic_sales: "organic_sales_percent",
  organic_units: "organic_units_percent",
  organic_page_views: "organic_page_views_percent",
  org_conv_rate: "org_conv_rate_delta",
  top_of_search_impression_share: "top_of_search_impression_share_delta",
  bsr: "bsr_percent",
  promo_sales: "promo_sales_percent",
  promo_units: "promo_units_percent",
  rods: "rods_delta",
  promo_conversion_rate: "promo_conversion_rate_delta",
  promo_cost: "promo_cost_percent",
  cogs: "cogs_percent",
  rating: "rating_percent",
  ratings_total: "ratings_total_percent",
  seo_score: "seo_score_percent",
  buyability_score: "buyability_score_percent",
  page_views: "page_views_percent",
  profit_per_page_view: "profit_per_page_view_percent",
  profit_per_page_view_wo_adspend: "profit_per_page_view_wo_adspend_percent",
  orders_same_sku: "orders_same_sku_percent",
  target_sales: "target_sales_prev",
  target_units: "target_units_prev",
  inc_cashflow: "inc_cashflow_prev",
  inc_contribution: "inc_contribution_prev",
  inc_units: "inc_units_prev",
  search_query_score: "search_query_score_prev",
  search_query_volume: "search_query_volume_percent",
  impressions_total: "impressions_total_percent",
  impressions_brand_or_asin: "impressions_brand_or_asin_percent",
  impressions_brand_or_asin_share: "impressions_brand_or_asin_share_delta",
  clicks_total: "clicks_total_percent",
  clicks_total_rate: "clicks_total_rate_delta",
  clicks_brand_or_asin: "clicks_brand_or_asin_percent",
  clicks_brand_or_asin_share: "clicks_brand_or_asin_share_delta",
  clicks_price_median: "clicks_price_median_percent",
  clicks_brand_or_asin_price_median: "clicks_brand_or_asin_price_median_percent",
  clicks_same_day_shipping_speed: "clicks_same_day_shipping_speed_percent",
  clicks_1d_shipping_speed: "clicks_1d_shipping_speed_percent",
  clicks_2d_shipping_speed: "clicks_2d_shipping_speed_percent",
  ctr_total: "ctr_total_delta",
  ctr_brand_or_asin: "ctr_brand_or_asin_delta",
  cv_total: "cv_total_delta",
  cv_brand_or_asin: "cv_brand_or_asin_delta",
  cart_adds_total: "cart_adds_total_percent",
  cart_adds_total_rate: "cart_adds_total_rate_delta",
  cart_adds_brand_or_asin: "cart_adds_brand_or_asin_percent",
  cart_adds_brand_or_asin_share: "cart_adds_brand_or_asin_share_delta",
  cart_adds_price_median: "cart_adds_price_median_percent",
  cart_adds_brand_or_asin_price_median: "cart_adds_brand_or_asin_price_median_percent",
  cart_adds_same_day_shipping_speed: "cart_adds_same_day_shipping_speed_percent",
  cart_adds_1d_shipping_speed: "cart_adds_1d_shipping_speed_percent",
  cart_adds_2d_shipping_speed: "cart_adds_2d_shipping_speed_percent",
  purchases_total: "purchases_total_percent",
  purchases_total_rate: "purchases_total_rate_delta",
  purchases_brand_or_asin: "purchases_brand_or_asin_percent",
  purchases_brand_or_asin_share: "purchases_brand_or_asin_share_percent",
  purchases_price_median: "purchases_price_median_percent",
  purchases_brand_or_asin_price_median: "purchases_brand_or_asin_price_median_percent",
  purchases_same_day_shipping_speed: "purchases_same_day_shipping_speed_percent",
  purchases_1d_shipping_speed: "purchases_1d_shipping_speed_percent",
  purchases_2d_shipping_speed: "purchases_2d_shipping_speed_percent",
  purchases_same_day_shipping_speed_percentage: "purchases_same_day_shipping_speed_percentage_percent",
  purchases_1d_shipping_speed_percentage: "purchases_1d_shipping_speed_percentage_percent",
  purchases_2d_shipping_speed_percentage: "purchases_2d_shipping_speed_percentage_percent",
};

export const PRICING_METRICS = [
  "min_price",
  "max_price",
  "suggested_price",
  "profit_per_page_view",
  "profit_per_page_view_wo_adspend",
  "boosted_profit",
];

export const CONTENT_METRICS = ["seo_score", "buyability_score"];

export const PROMO_METRICS = ["promo_sales", "promo_units", "rods", "promo_conversion_rate", "promo_cost"];

export const KDP_METRICS = ["kenp_pages_read", "kenp_royalties", "acos_with_kenp"];
